<template>
    <div :class="{ 'Collapsible':true, 'open': open }">
        <button class="Collapsible-toggler" @click="open = !open"><slot name="toggler" /></button>
        <div v-if="open" class="Collapsible-container"><slot /></div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                open: false
            };
        }
    };
</script>
